import React from 'react';
import { Link } from 'react-router-dom';

interface TruncatedTitleWithTooltipProps {
  title: string;
  to?: string;
  className: string;
}

const tooltipClasses =
  'pointer-events-none invisible absolute left-0 top-full z-30 mt-2 w-max max-w-md translate-y-1 rounded-md border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-800 shadow-lg opacity-0 transition-all duration-150 delay-0 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100 group-hover:delay-1000 group-focus-within:visible group-focus-within:translate-y-0 group-focus-within:opacity-100 group-focus-within:delay-1000 sm:max-w-xl';

const TruncatedTitleWithTooltip: React.FC<TruncatedTitleWithTooltipProps> = ({
  title,
  to,
  className,
}) => {
  return (
    <div className="group relative w-full">
      {to ? (
        <Link to={to} className={className} title={title}>
          {title}
        </Link>
      ) : (
        <p className={className} title={title}>
          {title}
        </p>
      )}
      <span className={tooltipClasses} role="tooltip">
        {title}
      </span>
    </div>
  );
};

export default TruncatedTitleWithTooltip;
